import React, { useState } from "react";
import DownlightForm from "./DownlightForm";
import LinearForm from "./LinearLight";
import RectificationForm from "./RectificationForm";

const JobForm = () => {
  const [formType, setFormType] = useState("DOWNLIGHT");

  return (
    <div className="w-full  bg-[#f8fafc]">
      {/* COMPACT STICKY HEADER */}
      <div className="w-full bg-white border-b sticky top-0 px-4 py-2 flex justify-between items-center shadow-sm">
        <div className="flex items-center gap-4">
          <h1 className="text-lg font-bold text-slate-800 border-r pr-4">
            JOB CARD
          </h1>
          <div className="flex bg-slate-100 p-1 rounded-md border">
            <button
              onClick={() => setFormType("LINEARLIGHT")}
              className={`px-4 py-1 text-xs font-semibold rounded transition-all ${
                formType === "LINEARLIGHT"
                  ? "bg-indigo-600 text-white shadow"
                  : "text-slate-500 hover:bg-slate-200"
              }`}
            >
              LINEAR
            </button>
            <button
              onClick={() => setFormType("DOWNLIGHT")}
              className={`px-4 py-1 text-xs font-semibold rounded transition-all ${
                formType === "DOWNLIGHT"
                  ? "bg-orange-600 text-white shadow"
                  : "text-slate-500 hover:bg-slate-200"
              }`}
            >
              DOWNLIGHT
            </button>
            <button
              onClick={() => setFormType("RECTIFICATION")}
              className={`px-4 py-1 text-xs font-semibold rounded transition-all ${
                formType === "RECTIFICATION"
                  ? "bg-blue-600 text-white shadow"
                  : "text-slate-500 hover:bg-slate-200"
              }`}
            >
              RECTIFICATION
            </button>
          </div>
        </div>
      </div>

      <div className="w-full">
        {formType === "DOWNLIGHT" ? (
          <DownlightForm />
        ) : formType === "LINEARLIGHT" ? (
          <LinearForm />
        ) : (
          <RectificationForm />
        )}
      </div>
    </div>
  );
};

export default JobForm;
